export const UPDATE_SSL_DETAILS_FORM_DATA = 'UPDATE_SSL_DETAILS_FORM_DATA';
export const UPDATE_SSL_CURRENT_STEP = 'UPDATE_SSL_CURRENT_STEP';
export const UPDATE_LOADER = 'UPDATE_LOADER';
export const UPDATE_CHALLENGE_DATA = 'UPDATE_CHALLENGE_DATA';
export const UPDATE_CERTIFICATE_DATA = 'UPDATE_CERTIFICATE_DATA';
export const RESET_SSL_FORM = 'RESET_SSL_FORM';
